<template>
  <a class="msg-icon show-msg-btn" :class="{'unread': hasUnread}" href="javascript:void(0)" title="消息中心">
    <el-popover
      v-model="showMsg"
      placement="bottom"
      popper-class="msg-list-popover"
      trigger="click">
      <div class="msg-detail-box js-msg-detail-box show">
        <div class="message-list-box">
          <ul class="msg-list-container">
            <li v-for="msg in msgList" :class="{'unread': msg.isRead != 1}">
              <p class="msg-content"><a href="/v2/dist/message.html" target="_blank" rel="opener">{{ msg.title }}</a></p>
              <span class="time">{{msg.date | formatDate}}</span>
            </li>
          </ul>
          <div class="msg-operation">
            <a class="all" href="/v2/dist/message.html" target="_blank" rel="opener">所有消息</a>
            <a class="ignore" href="javascript:void(0)" @click="readMsg">忽略</a>
          </div>
        </div>
      </div>
      <i slot="reference" class="iconfont icon_huaban1"></i>
    </el-popover>
  </a>
</template>
<script>
  import {getMsgList, readMsg} from '../api.js';
  import {DateUtils} from 'common/utils.js';
  export default {
    name: 'msg',
    data() {
      return {
        showMsg: false,
        hasUnread: false,
        msgList: []
      }
    },
    filters: {
      formatDate(date) {
        return DateUtils.format(date, 'yyyy-MM-dd');
      }
    },
    created() {
      this.getMsg();
    },
    methods: {
      async getMsg() {
        const params = {
          status: 1,
          categoryId: 0,
          type: 1,
          page: 1,
          pageSize: 3
        };
        const {records} = await getMsgList(params);
        this.msgList = records;
        this.hasUnread = records.length > 0;
      },
      async readMsg() {
        const idlist = this.msgList.map(item => {
          return {
            id: item.id,
            categoryId: item.categoryId
          }
        });
        await readMsg({announcementStatus: 2, notificationRequestList: idlist});
        this.showMsg = false;
        console.log(this.showMsg)
        this.getMsg();
      }
    }
  }
</script>